import MaskDirectLogin from '../../src/legacy/MaskDirectLogin';
export default MaskDirectLogin;
